import { Search } from "@mui/icons-material";
import { Button, Divider, Grid, InputBase, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { IMetaData } from "../../../Components/Dialog/WSCommonDialog";
import Notes from "../../Notes/Notes";
import { openPopUp } from "../../../Components/Dialog/OpenNewModal";
import { callAPI, createObject, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useNavigate, useParams } from "react-router-dom";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";

export const OverViewEstimation: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getEstimationPermission;
    const navigate = useNavigate();
    const params = useParams();
    const [estimatesData, setEstimatesData] = useState<any>([])
    const id = params?.id;
    const isMobile = IsSmallScreen();
    const [resetLoad, setResetLoad] = useState(false)
    useEffect(() => {

        const getEstimates = async () => {
            try {
                setResetLoad(false)
                const response: any = await callAPI(`estimates/lead/${id}`, Method.GET, null, null);
                setEstimatesData(response?.data);
            }
            catch (e) {

            }
        }
        getEstimates();
    }, [resetLoad])
    const columns: IColumns[] = [
        {
            header: "Name",
            fieldName: "customerName",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Amount",
            fieldName: "grandTotal",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined, "Convert to Quatation", "Print"].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`estimation/${row?.id}`)
        }
        else if (action === "Print") {
            navigate(`/estimation/print/${row?.id}`);
        }
        else if (action === 'Convert to Quatation') {
            navigate(`quatation/convert-quatation/${row?.id}`);

        }
    }
    const source = {
        url: "estimates/search",
        page: 1,
        pageSize: 10,
        filter: [],
        sort: [],
    };

    const handleEstimateAddClick = () => {

        navigate(`estimation`)

    }
    return (
        <Grid>
            <Grid container spacing={2} sx={{ marginTop: 2 }}>

                {view ? <Grid item xs={12}>
                    <WSDataGrid
                        id="estimateGrid"
                        title="Estimates"
                        columns={columns}
                        data={estimatesData}
                        gridHeaderSx={{
                            backgroundColor: "whitesmoke",
                            border: "1px solid whitesmoke",
                        }}
                        addButton={add ? { label: "New", color: "secondary" } : undefined}
                        onAddButtonClick={handleEstimateAddClick}
                    />
                </Grid>
                    : <PermissionDenied />}
            </Grid>
        </Grid>
    );
});
